import React, { useCallback } from 'react';
import { Drawer } from 'grab-ui';
import PropTypes from 'prop-types';
import styles from './common-styles.less';
import { useOverlayLayout } from './common-hook';

const CommonOverlay = ({ overlayKey, visible, children, onClose }) => {
  /*
  * A common overlay panel
  */

  const { width, placement } = useOverlayLayout();

  const onCloseFunc = useCallback(
    () => {
      onClose();
    },
    [onClose],
  );

  return (
    <Drawer
      key={overlayKey}
      width={width}
      placement={placement}
      visible={visible}
      className={styles.overlayDrawer}
      height="100%"
      onClose={onCloseFunc}
      destroyOnClose
    >
      {children}
    </Drawer>
  );
};

CommonOverlay.propTypes = {
  onClose: PropTypes.func,
  children: PropTypes.node,
  overlayKey: PropTypes.string,
  visible: PropTypes.bool,
};

CommonOverlay.defaultProps = {
  visible: false,
  onClose: undefined,
  children: undefined,
  overlayKey: undefined,
};

export default CommonOverlay;
